export * from './retailersMapper';
